import { z } from 'zod';
import { requireAtLeastOneField } from '../zod-helpers/index.js';
import { addressNameSchema, addressPartSchemas, addressSchema, nameSchema, } from './create-input.js';
export function buildUpdateAddressInputSchema(typeIdSchema, strictness = {}) {
    const parts = addressPartSchemas(strictness);
    return requireAtLeastOneField(z.object({
        name: nameSchema.optional(),
        addressName: addressNameSchema.optional(),
        typeId: typeIdSchema.optional(),
        address: addressSchema.optional(),
        // WHY: a partial update may omit any field, so strictness here means a sent value cannot be
        // blank -- not that every field must be present.
        city: parts.city.optional(),
        stateId: parts.stateId.optional(),
        countryId: parts.countryId.optional(),
        zip: parts.zip.optional(),
        defaultFlag: z.boolean().optional(),
    }));
}
//# sourceMappingURL=update-input.js.map